import { isDiscountedType } from '../context/PurchaseContext';
import { ProductSkuType } from '../types/services-api';
import { formatCurrency } from './displayHelper';

export function formatPrice(price: number) {
  return price % 1 > 0 ? formatCurrency(price) : `$${price.toLocaleString()}`;
}

export function calculateFee(product: ProductSkuType) {
  const fee = isDiscountedType(product) ? product.discountFee : product.fee;
  const activationFee = isDiscountedType(product)
    ? product.discountActivationFee
    : product.activationFee;
  return { fee, activationFee };
}
